module.exports = __webpack_public_path__ + "static/pic06-8508ce2598654e64a7aebd26e1b5ca2c.jpeg";